import { motion } from "framer-motion";
import content from "../data/content.json";
import { useSiteHome } from "../hooks/useSiteHome";
import { useHeroChromeIdle } from "./HeroIdleChrome";

const StatsBar = () => {
  const { data } = useSiteHome();
  const stats = data?.stats || content.stats;
  const chromeIdle = useHeroChromeIdle();

  return (
    <section
      className={`stats-bar relative z-50 -mt-16 md:-mt-24 isolate transition-opacity duration-300 ${
        chromeIdle ? "pointer-events-none opacity-0" : "opacity-100"
      }`}
      style={{ isolation: "isolate" }}
    >
      <div className="container mx-auto px-6">
        <div className="bg-brand-dark border border-white/10 backdrop-blur-md shadow-2xl rounded-[32px] py-10 md:py-14">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex flex-col items-center text-center md:border-r last:border-0 border-white/10"
              >
                <div className="flex items-baseline">
                  <span className="text-5xl md:text-6xl font-display font-medium text-brand-accent tracking-tighter">
                    {stat.value}
                  </span>
                  <span className="text-2xl font-display font-light text-brand-accent ml-1">
                    {stat.suffix}
                  </span>
                </div>
                <p className="text-white/40 uppercase text-[11px] font-bold tracking-[0.4em] mt-3">
                  {stat.label}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
